import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import Navigation from './components/Navigation'
import Footer from './components/Footer'
import ErrorBoundary from './components/ErrorBoundary'
import ProtectedRoute from './components/ProtectedRoute'
import LoginForm from './components/LoginForm'
import RegisterForm from './components/RegisterForm'
import ForgotPasswordForm from './components/ForgotPasswordForm'
import AuthCallback from './components/AuthCallback'
import AuthLogout from './components/AuthLogout'
import NewPasswordForm from './components/NewPasswordForm'
import HomePage from './pages/HomePage'
import SitesPage from './pages/SitesPage'
import ContactPage from './pages/ContactPage'
import WindRosePage from './pages/WindRosePage'
import FlightLogsPage from './pages/FlightLogsPage'
import FlightLogEditor from './pages/FlightLogEditor'
import ShopPage from './pages/ShopPage'
import AdminPage from './pages/AdminPage'
import ProfilePage from './pages/ProfilePage'
import MembershipPage from './pages/MembershipPage'
import PrivacyPage from './pages/PrivacyPage'
import TermsPage from './pages/TermsPage'
import CookiePage from './pages/CookiePage'
import AboutPage from './pages/AboutPage'
import SafetyPage from './pages/SafetyPage'
import LinksPage from './pages/LinksPage'
import InfoPage from './pages/InfoPage'
import NewsPage from './pages/NewsPage'
import GalleryPage from './pages/GalleryPage'
import SupportPage from './pages/SupportPage'
import ContentManager from './components/ContentManager'
import ContentEditor from './components/ContentEditor'
import './App.css'
import './styles/pages.css'

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <Router>
          <div className="App">
            <Navigation />

            <main className="main-content">
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<HomePage />} />
                <Route path="/sites" element={<SitesPage />} />
                <Route path="/sites/:siteId" element={<SitesPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/wind-rose" element={<WindRosePage />} />
                <Route path="/news" element={<NewsPage />} />
                <Route path="/news/:newsId" element={<NewsPage />} />
                <Route path="/gallery" element={<GalleryPage />} />
                <Route path="/support" element={<SupportPage />} />
                <Route path="/flight-logs" element={<FlightLogsPage />} />
                <Route
                  path="/flight-logs/new"
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <FlightLogEditor />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/flight-logs/:logId/edit"
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <FlightLogEditor />
                    </ProtectedRoute>
                  }
                />
                <Route path="/flight-logs/:logId" element={<FlightLogsPage />} />
                <Route path="/shop" element={<ShopPage />} />
                <Route path="/membership" element={<MembershipPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/safety" element={<SafetyPage />} />
                <Route path="/links" element={<LinksPage />} />
                <Route path="/radios" element={<InfoPage slug="radios" />} />
                <Route path="/training" element={<InfoPage slug="training" />} />
                <Route path="/info/:slug" element={<InfoPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/cookies" element={<CookiePage />} />
                
                {/* Authentication Routes */}
                <Route path="/login" element={<LoginForm />} />
                <Route path="/new-password" element={<NewPasswordForm />} />
                <Route path="/forgot-password" element={<ForgotPasswordForm />} />
                
                {/* Admin-only Routes */}
                <Route 
                  path="/admin/invite" 
                  element={
                    <ProtectedRoute requireAuth={true} requireAdmin={true}>
                      <RegisterForm />
                    </ProtectedRoute>
                  } 
                />
                
                {/* Protected Routes */}
                <Route 
                  path="/profile" 
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <ProfilePage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin" 
                  element={
                    <ProtectedRoute requireAuth={true} requireAdmin={true}>
                      <AdminPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/content" 
                  element={
                    <ProtectedRoute requireAuth={true} requireAdmin={true}>
                      <ContentManager />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/content/new" 
                  element={
                    <ProtectedRoute requireAuth={true} requireAdmin={true}>
                      <ContentEditor />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/content/edit/:contentId" 
                  element={
                    <ProtectedRoute requireAuth={true} requireAdmin={true}>
                      <ContentEditor />
                    </ProtectedRoute>
                  } 
                />
                
                {/* OAuth Callback Routes */}
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/auth/logout" element={<AuthLogout />} />
                
                {/* Catch-all route for 404 */}
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </main>

            <Footer />
          </div>
        </Router>
      </AuthProvider>
    </ErrorBoundary>
  )
}

// Simple 404 component
function NotFoundPage() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Page Not Found</h1>
        <p>The page you're looking for doesn't exist</p>
      </div>
      <div className="page-content">
        <div className="coming-soon">
          <p>Return to the <a href="/">homepage</a> to continue browsing.</p>
        </div>
      </div>
    </div>
  )
}

export default App